import React, { useEffect, useRef, useState } from 'react'
import './manager-activity-list.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faGlobeAmericas, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import DetailedActivityList from '@/components/SHARED/detailed-activity-list/detailed-activity-list.component';
import { useSelector } from 'react-redux';
import { getActivityRecordsQuery, getRegsFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import DetailedActivityListTable from '@/components/SHARED/detailed-activity-list/detailed-activity-list-table.component';
import Modal from '@/components/modal/modal.component';
import ActivityFilters from '@/components/SHARED/detailed-activity-list/activity-filters.component';
import ActivityFiltersV2 from '@/components/SHARED/detailed-activity-list/activity-filters-v2.component';
import TransactionView from '@/components/SHARED/tranaction-view/transaction-view.component';

const ManagerActivityList = ({
  gameData,
  defaultActivityRecords,
  playerList,
  gameElements,
  gameManagers,
  typeOnly
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [activityToDisplay, setActivityToDisplay] = useState({});
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [queryFilter, setQueryFilter] = useState([]);
  const [resetFilter, setResetFilter] = useState(false);
  const [noMore, setNoMore] = useState(false);
  const [moreLimit, setMoreLimit] = useState(15);
  const activityRef = useRef({});
  const filterRef = useRef([]);
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    if (
      location.pathname === `/manage/${gameData.path}/activity` ||
      location.pathname === `/manage/${gameData.path}/marketplace/purchases`
    ) {
      console.log('scrolling')
      let scrollElement;
      if (screenSize === 'mobile') {
        scrollElement = document.querySelector('.detailed-activity-list-table');
      } else {
        scrollElement = document.querySelector('#scroll-to-top');
      }

      if (scrollRef.current) {
        const timeout = setTimeout(() => {
          scrollElement.scrollTo({
            'behavior': 'smooth',
            'top': scrollRef.current + 40
          });
          clearTimeout(timeout);
        }, 100);
      } else {
        scrollElement.scrollTo({
          'behavior': 'smooth',
          'top': 0
        });
      }
    }

  }, [location])

  useEffect(() => {
    console.log(playerList);
  }, [playerList])

  useEffect(() => {
    if (!defaultActivityRecords) {
      getActivityData();
      return;
    };
    console.log('queryFilter', queryFilter);
    activityRef.current = {
      ...activityRef.current,
      ...defaultActivityRecords
    };
    console.log(activityRef.current);
    setActivityToDisplay(activityRef.current);
    setNoMore(false);
  }, [defaultActivityRecords])

  function getActivityData(next) {
    if (typeOnly) {
      queryFilter.push({
        'key': 'type',
        'value': typeOnly
      })
    }
    if (!typeOnly && !next && queryFilter?.length === 0) {
      activityRef.current = {...defaultActivityRecords};
      setActivityToDisplay(activityRef.current);
      setNoMore(false);
      return;
    } else if (typeOnly || next || queryFilter?.length > 0) {
      const queryObject = {
        'gameId': gameData.gameId,
        'path': 'activityRecords',
        'filter': queryFilter,
        'limit': moreLimit,
        'once': true,
        'callback': callback
      }
      if (next) {
        const len = Object.keys(activityRef.current).length
        queryObject.lastEntry = Object.values(activityRef.current)
        .sort((a, b) => a.ts < b.ts ? 1 : -1)[len - 1];
      }
      // Handle 'next' filter
      getActivityRecordsQuery(queryObject)
    }

    function callback(data) {
      console.log(data);
      if (next) {
        activityRef.current = {
          ...activityRef.current,
          ...data
        };
      } else {
        activityRef.current = {...data};
      }
      if (Object.keys(data).length < moreLimit) {
        setNoMore(true);
      } else {
        setNoMore(false);
      }
      setActivityToDisplay(activityRef.current);
    }
  }

  function goToTransaction(path) {
    if (screenSize === 'mobile') {
      scrollRef.current = document.querySelector('.detailed-activity-list-table').scrollTop;
    } else {
      scrollRef.current = document.querySelector('#scroll-to-top').scrollTop;
    }
    navigate(path);
  }

  function nextPage() {

    getActivityData(true);
    const timeout = setTimeout(() => {
      if (screenSize === 'mobile') {
        scrollRef.current = document.querySelector('.detailed-activity-list-table').scrollTop;
      } else {
        scrollRef.current = document.querySelector('#scroll-to-top').scrollTop;
      }
      clearTimeout(timeout);
    }, 200)
  }

  return (
    <div className={`manager-activity-list ${screenSize}`}>
      <Routes>
        <Route path='' element={
          <div className='manager-activity-content g-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className='g-space-1'></div>
            {
              (typeOnly === 'purchase')
              ?
              <div className='card-title'>
                <FontAwesomeIcon icon={faShoppingCart} />
                Purchases
              </div>
              :
              (!typeOnly)
              ?
              <div className='card-title'>
                <FontAwesomeIcon icon={faGlobeAmericas} />
                Game Activity Records
              </div>
              :
              null
            }
            <hr />
            <div className='filter-row buttons'>
              <button
                className='g-button small-btn'
                onClick={() => setShowFilterModal(true)} >
                Filter
                <FontAwesomeIcon 
                  className={
                    queryFilter
                    ?.filter(q => q.key !== 'type')
                    .length > 0 ? 'active' : 'inactive'}
                  icon={faFilter} />
              </button>
            </div>
            <div className="g-space-1"></div>
            <DetailedActivityListTable
              gameData={gameData}
              activityToDisplay={activityToDisplay}
              playerList={playerList}
              gameElements={gameElements}
              manager={true}
              gameManagers={gameManagers}
              goToTransaction={goToTransaction}
            />
            <div className="g-space-1"></div>
            <div className='center-col'>
              <button
                className={`g-button small-btn ${noMore ? 'disabled' : ''}`}
                onClick={() => nextPage()}>
                Load More...
              </button>
            </div>
          </div>
        }></Route>
        <Route
          path=':transPath'
          element={
            <div className='transaction-container'>
              <div className='transaction-card g-card'>
                <TransactionView
                  activityToDisplay={activityToDisplay}
                  playerList={playerList}
                  gameElements={gameElements}
                  gameManagers={gameManagers} />
              </div>
            </div>
          }
        ></Route>
      </Routes>
      <Modal
        show={showFilterModal}
        cancel={() => setShowFilterModal(false)}
        text="Filter Activity Records"
        closeButton={true}
        cls="narrow" >
        <div className='filter-modal-content'>
          <ActivityFiltersV2
            gameData={gameData}
            gameManagers={gameManagers}
            playerList={playerList}
            gameElements={gameElements}
            setQueryFilter={setQueryFilter}
            resetFilter={resetFilter}
            setResetFilter={setResetFilter}
          />
          <hr />
          <div className='buttons'>
            <button
              className='g-button med-btn'
              onClick={() => setResetFilter(true)}>
              Clear Filters
            </button>
            <button
              className='g-button med-btn primary'
              onClick={() => {
                setShowFilterModal(false);
                getActivityData(false)
                }
              }>
              Apply Filters
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )

}

export default ManagerActivityList  